// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jpmAg","rootNoMargin":"styles_rootNoMargin__2vWN0"};